import { render } from "./EnableWhatsApp.vue?vue&type=template&id=31e9f2a3"
import script from "./EnableWhatsApp.vue?vue&type=script&lang=js"
export * from "./EnableWhatsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__